import root from 'window-or-global';

/**
 * This file should not be imported by components.  The prop.message object passed into EpicGamesNav should be used instead.
 * This is just a reference and default in case there is not message props.
 * @type {Object}
 */
const defaultMessages = {
    tos: 'Terms of Service',
    privacy: 'Privacy Policy'
};

//allow the root._epicGamesFooter.messages to override the constants
if (root._epicGamesFooter && root._epicGamesFooter.messages) {
    for (const message in defaultMessages) {
        if (root._epicGamesFooter.messages[message]) {
            defaultMessages[message] = root._epicGamesFooter.messages[message];
        }
    }
}

module.exports = defaultMessages;



// WEBPACK FOOTER //
// ./app/scripts/constants/defaultMessages.js